export const load = () => ({
	title: 'Blackout Your Windows With Sleep Panels',
	h1: 'How To Block Sunlight During The Day',
	description:
		"Whether you're a daysleeper or struggle with bright street lights at night, getting restful sleep can be a challenge if you can't prevent light from seeping in through your windows.",
	showTitle: true,
});
